import Vue from "vue"
import Vuex from "vuex"

import account from "./modules/account"
import general from "./modules/general"
import photos from "./modules/photos"
import places from "./modules/places"
import prices from "./modules/prices"
import profile from "./modules/profile"
import stats from "./modules/stats"
import videos from "./modules/videos"
import plans from "./modules/plans"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    account,
    general,
    photos,
    places,
    prices,
    profile,
    stats,
    videos,
    plans,
  },
})
